import { TooManyOtpAttempts } from "./pages/shared/components/exceptions/tooManyOtpAttempts";

export interface PhoneType {
  code: string;
  number: string;
}

export enum IAMExceptionType {
  TOO_MANY_EMAIL_OTP_ATTEMPTS = "TOO_MANY_EMAIL_OTP_ATTEMPTS",
}

export const IAMExceptionTypeToComponentMap = {
  [IAMExceptionType.TOO_MANY_EMAIL_OTP_ATTEMPTS]: TooManyOtpAttempts,
};

export type Gender = "MALE" | "FEMALE";
